// Zentraler Body-Scroll-Lock mit Referenz-Zähler.
//
// Vorher hielt jedes Overlay (Modal, Drawer, MobileNav, Mapping-Panel) sein
// eigenes previousOverflow und stellte es beim Schließen wieder her. Bei
// gestapelten Overlays, die out-of-order schließen — z. B. wenn ein Modal
// unmountet, während ein zweites noch offen ist —, restauriert das zuletzt
// schließende Overlay dann "hidden": Der Body bleibt app-weit unscrollbar,
// bis der User hart neu lädt (Max' Prod-Befund 04.08.: Artikel-Seite
// scrollte nicht mehr, Hard-Reload half).
//
// Der Zähler macht die Schließ-Reihenfolge egal: gesperrt, solange
// mindestens ein Overlay offen ist; frei, sobald das letzte schließt.
let locks = 0;

export function lockBodyScroll(): void {
  locks += 1;
  if (locks === 1) document.body.style.overflow = "hidden";
}

export function unlockBodyScroll(): void {
  locks = Math.max(0, locks - 1);
  if (locks === 0) document.body.style.overflow = "";
}
